module.exports = __webpack_public_path__ + "static/mini_bleu-4ef2c76c2ad5900c7060caf537405681.jpg";